@use '@hevoio/hevo-ui-toolkit/styles/variables' as v;

.stickyStatusCell {
  position: sticky;
  right: 0;
  z-index: 2;
  background-color: var(--zora-bg-white-0);
  box-shadow: -8px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.stickyStatusHeader {
  // Toolkit sets `._tableHeader ._tableHeaderCell { position: relative }` via a
  // descendant selector that out-specifies a single class — force sticky.
  position: sticky !important;
  right: 0;
  z-index: 3;
  background-color: var(--surface-bg-alternate-color);
  box-shadow: -8px 0 8px -8px rgba(0, 0, 0, 0.15);
}

.acceptanceBanner {
  display: flex;
  align-items: center;
  gap: v.$spacer-8;
  width: 100%;
  padding: v.$spacer-10 v.$spacer-16;
  background-color: var(--surface-bg-alternate-color);
  font-size: 13px;
  line-height: 18px;
  color: var(--text-sub-600);
}

.howToAcceptLink {
  padding: 0;
  border: 0;
  background: none;
  color: var(--primary-base);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.whyExplanation {
  margin: v.$spacer-6 0 0;
  max-width: 720px;
  color: var(--text-sub-600);
}
